// import styled from 'styled-components';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const Spinner = styled.div`
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-top: 2px solid #D40020;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: ${spin} 1s linear infinite;
  display: inline-block;
  align-self: center;
`;

export const Plate = styled.div`
  width: 220px;
  height: 76px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url("images/plate.svg");
  font-family: Consolas;
  font-weight: 400;
  font-size: 40px;
  line-height: 47px;
  color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 5px;
  align-self: center;
  margin-top: 20px;
`;

export const Chassis = styled.div`
  width: 220px;
  height: 76px;
  font-family: Consolas;
  font-weight: 400;
  font-size: 40px;
  line-height: 47px;
  color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 5px;
  align-self: center;
`;

export const Description = styled.div`
  font-family: Consolas;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: #2E9346;
  align-self: center;
  margin-top: -5px;
`;
